import monthlyReportTotalReducer from "./monthlyReportTotalReducer";
import monthlyReportSettlementReducer from "./monthlyReportSettlementReducer";

const monthlyReportReducers = {
    monthlyReportTotal: monthlyReportTotalReducer,
    monthlyReportSettlement: monthlyReportSettlementReducer
};

export default monthlyReportReducers;